import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=932b4354&scoped=true"
import script from "./basicInfo.vue?vue&type=script&lang=js"
export * from "./basicInfo.vue?vue&type=script&lang=js"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=932b4354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932b4354",
  null
  
)

export default component.exports